import React,{useContext} from "react";
import {
  SkillsPage,
  SkillsScreen,
  SkillsMainContainer,
  SkillsLottieContainer,
  SkillsDataContainer,
  SkillGrid,
  SkillLottie
} from "./skills.styles";

//libs
import Lottie from "react-lottie";
import { Fade } from "react-reveal";
import { Grid } from "@mui/material";

//assets
import skillsLottie from "../../assets/lotties/skills5.json";

//components
import SkillOverview from "../../components/skillOverview/skillOverview.component";

//utils
import skills from "../../utils/skills.data";

import {ThemeContext} from '../../theme.context';

const Skills = () => {
  const skillsLottieOptions = {
    loop: true,
    autoplay: true,
    animationData: skillsLottie,
    rendererSettings: {
      preserveAspectRatio: "xMidYMid slice",
    },
  };

  const {darkMode} = useContext(ThemeContext);

  return (
    <SkillsPage>
      <div class="custom-shape-divider-bottom-1646408644">
        <svg
          data-name="Layer 1"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1200 120"
          preserveAspectRatio="none"
        >
          <path
            d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"
            class="shape-fill"
            fill={darkMode?"#1C2028":"#fff"}
          ></path>
        </svg>
      </div>
      <SkillsScreen id="skills-section" dark={darkMode}>
        <Fade left>
          <h1 className="page-title">MY SKILLS !</h1>
        </Fade>

        <SkillsMainContainer>
          <Fade left delay={1000}>
            <SkillsLottieContainer>
              <SkillLottie>
              <Lottie options={skillsLottieOptions} width="100%" height="100%" />

              </SkillLottie>
            </SkillsLottieContainer>
          </Fade>
          <SkillsDataContainer>
            <SkillGrid container>
              {skills.map((skill, idx) => (
                <Grid item md={3} sm={3}>
                  <SkillOverview skill={skill} value={skill?.value} dark={darkMode} />
                </Grid>
              ))}
            </SkillGrid>
          </SkillsDataContainer>
        </SkillsMainContainer>
      </SkillsScreen>
    </SkillsPage>
);
};

export default Skills;
